module.exports = __webpack_public_path__ + "img/オペレーティングシステム3-1.a69b7ac1.png";